/***
 *
 * @param {Setting} setting - Setting to check the value of
 * @param {String} trueClass - Class if the setting is true
 * @param {String} falseClass - Class if the setting is false
 * @returns {Object.<String, Boolean>} - Vue v-bind:class object
 */
export default (setting, trueClass, falseClass) => {
    return Object.fromEntries([[trueClass, setting.value], [falseClass, !setting.value]]);
};